import { resolveCorrespondingStatName }   from './schema.js';
import { findOneById, filterManyByIds }   from '../../../utilities/idResolution.js';

export const filterValidMults = (selectedComparablesData, multFieldChoosen) => {
  return selectedComparablesData.filter((company) => {
    const multValue = company[multFieldChoosen];
    return multValue !== "N/A" && multValue > 0;
  });
}

export const getMaxMult = (companies, multChoosen) => {
  return Math.max(...companies.map((coData)=>coData[multChoosen]))
}

export const getMinMult = (companies, multChoosen) => {
  return Math.min(...companies.map((coData)=>coData[multChoosen]))
}

export const buildSP = (multiple, multName, obj) => {
  const statName = resolveCorrespondingStatName(multName);
  console.log("[STAT NAME]: ", statName)
  const statValue = obj[statName];
  console.log("[STAT VALUE]: ", statValue.toFixed(2))

  if (statName.includes('Eps')) {
    const sharePrice = multiple * statValue;
    return sharePrice
  } else {
    const EV          = multiple * statValue;
    const EqV         = EV - obj.totalDebt + obj.totalCash;
    const sharePrice  = EqV / obj.shares;
    return sharePrice
  }
}

export const getMaxSP = (bars) => {
  // flatMap runs your callback like map would, but instead of nesting each returned array it concatenates their contents into one flat array
  // bars.flatMap(bar => [bar.high, bar.low])
  // result = [ 15.71, 5.38, -9.94, -19.15, 31.60, 8.19 ]
  const sharePrices = bars.flatMap(bar => [bar.high, bar.low])
  return Math.max(...sharePrices)

}

export const getMinSP = (bars) => {
  // flatMap runs your callback like map would, but instead of nesting each returned array it concatenates their contents into one flat array
  // bars.flatMap(bar => [bar.high, bar.low])
  // result = [ 15.71, 5.38, -9.94, -19.15, 31.60, 8.19 ]
  const sharePrices = bars.flatMap(bar => [bar.high, bar.low])
  return Math.min(...sharePrices)

}

// ============= Mult Resolution ================= //

export const findValuationTileInTray = (tiles, ids, valuationOptions) => {
  // resolve ids of tiles in stored in tray state, to full tile objects
  const tilesInComponentTrays = filterManyByIds(tiles, ids)
  console.log("[TILES IN COMPONENT TRAYS]: ", tilesInComponentTrays)
  // see if any of them are a valuation tile, and if so, return the first one found 
  // i.e. .find() method ends exeuction after first match
    // if match found:  return value is a single object / whatever shape the 'elements' are in the array
    // if not:          return value is undefined

  const valuationTileInTray = tilesInComponentTrays.find(tile => valuationOptions.includes(tile.field));
  console.log("[FIRST VALUATION TILE FOUND IN COMPONENT TRAYS]: ", valuationTileInTray)
  return valuationTileInTray
}

const resolveIfNonReported = (company, defaultMultName, key) => {
  if(company[`ttm${key}Multiple`] === "N/A") return defaultMultName
  return `ttm${key}Multiple`
}

export const checkMult = (company, defaultMultName, valuationTile) => {
/*
    const compsTilesResponse = [
        { id: 1,  name: 'EV',                          field: 'EV'                          },
        { id: 2,  name: 'Market Cap',                  field: 'marketCapitalization'        },
        { id: 7,  name: 'Forward Revenue Growth',      field: 'forwardRevenueGrowth'        },
        { id: 5,  name: 'Forward Revenue Multiple',    field: 'nextYearRevenueMultiple'     },
        { id: 6,  name: 'Current Revenue Growth',      field: 'currentRevenueGrowth'        },
        { id: 4,  name: 'Current Revenue Multiple',    field: 'currentYearRevenueMultiple'  },
        { id: 3,  name: 'LTM Revenue Multiple',        field: 'ttmRevenueMultiple'          },
        { id: 9,  name: 'LTM EBITDA Margin',           field: 'ttmEbitdaMargin'             },
        { id: 8,  name: 'LTM EBITDA Multiple',         field: 'ttmEbitdaMultiple'           },
        { id: 14, name: 'Forward Earnings Growth',     field: 'forwardEarningsGrowth'       },
        { id: 12, name: 'Forward Earnings Multiple',   field: 'nextYearPeMultiple'          },
        { id: 13, name: 'Current Earnings Growth',     field: 'currentEarningsGrowth'       },
        { id: 11, name: 'Current Earnings Multiple',   field: 'currentYearPeMultiple'       },
        { id: 10, name: 'LTM Earnings Multiple',       field: 'ttmPeMultiple'               },
        { id: 15, name: 'Rule of 40',                  field: 'ruleOf40'                    }
    ]


    const transTilesResponse = [
        { id: 'dealSize',           name: 'Deal Size',              field: 'dealSize' },
        { id: 'premiumPaid',        name: 'Premium Paid',           field: 'premiumPaid' },
        { id: 'ttmRevenueMultiple', name: 'LTM Revenue Multiple',   field: 'ttmRevenueMultiple' },
        { id: 'ttmRevenueGrowth',  name: 'LTM Revenue Growth',      field: 'ttmRevenueGrowth' },
        { id: 'ttmEbitdaMultiple',  name: 'LTM EBITDA Multiple',    field: 'ttmEbitdaMultiple' },
        { id: 'ttmEbitdaMargin',  name: 'LTM EBITDA Margin',        field: 'ttmEbitdaMargin' }
    ]
*/

  if (!valuationTile) return defaultMultName;

  let multipleName = valuationTile.field
  console.log("[CHECKING CHARTED MULTIPLE]: ", multipleName)
  console.log("[COMPANY RESULT]:            ", company[multipleName])

  if (company[multipleName] === "N/A") {
    if (multipleName.includes('Revenue'))   multipleName = 'ttmRevenueMultiple';
    if (multipleName.includes('Pe'))        multipleName = 'ttmPeMultiple';
    if (multipleName.includes('Ebitda'))    multipleName = resolveIfNonReported(company, defaultMultName, 'Ebitda');
  
    console.log("['N/A' FALLBACK MULTIPLE USED FOR]: ", company.ticker)
    console.log("[FALLBACK MULTIPLE NAME RESULT]     ", multipleName) 
    return multipleName
  }
  console.log("[MULTIPLE NAME RESULT]: ", multipleName)
  return multipleName
}
